import apiUtils from './ApiUtils'

const toJson = (str) => {
  return JSON.parse(str.replace(/^(\s|")+|(\s|")+$/g, '\''))
}

// 安卓
const androidBridge = {
  // 请求参数
  async getQueryParam () {
    try {
      const queryParam = toJson(window.LitBridge.getQueryParam())
      return queryParam
    } catch (err) {
      console.warn(err)
      return {}
    }
  },
  /**
   * 判断某个接口在当前版本的app是否可用
   * @param {*} API 接口名称
   */
  async canIUse (API) {
    const { androidVer, compareVersion } = apiUtils
    const minVer = androidVer[API]
    if (!minVer) {
      console.error('android bridge不支持该api', API)
      return false
    }
    try {
      const { version: nowVersion } = await this.getQueryParam()
      return compareVersion(nowVersion, minVer)
    } catch (err) {
      console.error(err)
      return false
    }
  },
  // 获取当前用户信息
  async getUserInfo () {
    try {
      const userInfo = toJson(window.LitBridge.getUserInfo())
      return userInfo
    } catch (err) {
      console.warn(err)
      return { }
    }
  },
  // 获取当前国家
  async getLoc () {
    try {
      let loc = window.LitBridge.getLang()
      if (loc === 'VI') {
        loc = 'VN'
      }
      if (loc === 'IN') {
        loc = 'ID'
      }
      if (loc === 'MS') {
        loc = 'MY'
      }
      return loc
    } catch (err) {
      console.warn(err)
      return 'EN'
    }
  },

  // 客户端相关信息【版本号等】
  async getClientInfo () {
    try {
      const clientInfo = toJson(window.LitBridge.getClientInfo())
      return clientInfo
    } catch (err) {
      console.warn(err)
      return {}
    }
  },
  /**
   * 打点
   * @param {
   *  eventName, //事件显示名
   *  action // 打点事件
   *  ...// 其它信息
   * } point
   */
  async analyse (point) {
    console.log('android->>>>>打点', point)
    try {
      window.LitBridge.analyse(JSON.stringify(point))
    } catch (err) {
      console.warn(err)
    }
  },
  /**
   * 跳指定用户的 profile
   * @param {string} userId
   */
  async jumpToProfile (userId) {
    try {
      window.LitBridge.jumpToProfile(userId)
    } catch (err) {
      console.warn(err)
    }
  },
  /**
   * 跳指定商品id的支付页
   * @param {string} productId
   */
  async jumpToPay (productId) {
    try {
      window.LitBridge.jumpToPay(productId)
    } catch (err) {
      console.warn(err)
    }
  },
  /**
   * 跳指定语音房
   * @param {string} partyId
   */
  async jumpToParty (partyId) {
    try {
      window.LitBridge.jumpToParty(partyId)
    } catch (err) {
      console.warn(err)
    }
  },
  /**
   * 返回上一页
   */
  async backToPrePage () {
    try {
      window.LitBridge.backToPrePage()
    } catch (err) {
      console.warn(err)
    }
  },
  async jump2Activity(uri) {
    try {
      window.LitBridge.jump2Activity(uri)
    } catch (err) {
      console.warn(err)
    }
  },
  async jump2ActivityByRoute(route) {
    try {
      window.LitBridge.jump2ActivityByRoute(route)
    } catch (err) {
      console.warn(err)
    }
  },
  async showToast(str) {
    try {
      window.LitBridge.toast(str)
    } catch (err) {
      console.warn(err)
    }
  },
  async getStatusBarHeight() {
    try {
      const statusBarInfo = window.LitBridge.getStatusBarHeight()
      return statusBarInfo
    } catch (err) {
      console.warn(err)
      return 35
    }
  }
}
export default androidBridge
